








import Vue from "vue";

interface Props {
  body: string[];
}

export default Vue.extend<{}, {}, {}, Props>({
  name: "ListeningCard",
  props: {
    body: {
      type: Array,
      required: true
    }
  }
});
